import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { CommonFormContextProps, useCommonFormContextProps } from 'components/Form'
import { SectionHeader } from 'components/Header'
import { TextLink } from 'components/Link'
import Loading from 'components/Loading'
import Paper from 'components/Paper'
import { DISABLED_CONTAINER_OPACITY } from 'providers/material-ui/theme/constants'
import { KNOWLEDGE_BASE_URL } from './constants'
import {
  SetupRetargetingDeliveryItemsContext,
  SetupRetargetingDeliveryItemsContextType,
} from './context'
import { SetupRetargetingDeliveryItemsForm } from './SetupRetargetingDeliveryItemsForm'
import { useGetGamOrderRetargetingDealsDelivery } from './useGetGamOrderRetargetingDealsDelivery'

type Props = {
  disabled: boolean
}

export const SetupRetargetingDeliveryItemsSection = ({ disabled }: Props): JSX.Element => {
  const { t: tc } = useTranslation('common')
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.setupRetargetingDeliveryItems',
  })

  const { gamOrderRetargetingDealsDelivery, loading } = useGetGamOrderRetargetingDealsDelivery()

  const commonContextProps: CommonFormContextProps = useCommonFormContextProps({
    formId: `setup-retargeting-delivery-items-form`,
  })
  const contextProps: SetupRetargetingDeliveryItemsContextType = {
    gamOrderRetargetingDealsDelivery,
    ...commonContextProps,
  }

  return (
    <SetupRetargetingDeliveryItemsContext.Provider value={contextProps}>
      <Paper
        data-cy='setup-retargeting-deals-delivery-items-in-gam-section'
        variant='cream'
      >
        <Box
          {...(disabled && {
            sx: {
              opacity: DISABLED_CONTAINER_OPACITY,
              pointerEvents: 'none',
            },
          })}
        >
          <SectionHeader
            subtitle={t('header.description')}
            subtitleEndAdornment={
              <TextLink
                link={{
                  title: tc('learnMore'),
                  url: KNOWLEDGE_BASE_URL,
                }}
              />
            }
            title={t('header.title')}
          />
          <GapBox />

          {loading ? (
            <Loading />
          ) : (
            <SetupRetargetingDeliveryItemsForm
              errorMessage={gamOrderRetargetingDealsDelivery?.errorMessage}
            />
          )}
        </Box>
      </Paper>
    </SetupRetargetingDeliveryItemsContext.Provider>
  )
}
